var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3766 3.125C17.3328 3.125 12.4141 8.04375 12.4141 14.0875V82.7875C12.4141 88.8313 17.3328 93.75 23.3766 93.75H73.3266C79.3703 93.75 84.2891 88.8313 84.2891 82.7875V29.8187C84.2891 29.775 84.2516 29.7437 84.2453 29.7C84.2322 29.3329 84.0881 28.9826 83.8391 28.7125L58.8391 3.7125C58.5838 3.46961 58.2528 3.32178 57.9016 3.29375C57.7453 3.25 57.6203 3.125 57.4641 3.125H23.3766ZM23.3766 6.25H56.1641V20.5062C56.1641 26.5062 61.0391 31.3812 67.0328 31.3812H81.1641V82.7875C81.1641 87.1063 77.6453 90.625 73.3266 90.625H23.3766C21.2989 90.6217 19.3074 89.7949 17.8383 88.3258C16.3692 86.8567 15.5424 84.8651 15.5391 82.7875V14.0875C15.5391 9.76875 19.0641 6.25 23.3766 6.25ZM59.2766 8.70625C64.0953 13.4937 73.7516 23.0812 78.9453 28.2562H67.0328C62.7641 28.2562 59.2828 24.775 59.2828 20.5062L59.2766 8.70625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.8809508b5ad53e9f2c1af2e5fcfaf4c4.svg";
export { ForwardRef as ReactComponent };